import type { BaseStep } from './BaseStep'

export enum StepMetaType {
	HistoryClear = 'STEP_META_HISTORY_CLEAR',
	CloseView = 'STEP_META_CLOSE_VIEW',
}

export type StepMetaHistoryClear<T extends BaseStep> = {
	type: StepMetaType.HistoryClear
	step: T
}

export type StepMetaCloseView = {
	type: StepMetaType.CloseView
}

export type StepHandlerResult<T extends BaseStep = BaseStep> = T | StepMetaHistoryClear<T> | StepMetaCloseView

/**
 * Wrap step with instructions to clear current step stack if any. Should be used when navigating to a step where it
 * doesn't make sense to let the use navigate to the previous step, such as a completion splash screen.
 *
 * This only has an effect when using widgetapp container built-in stepping for now, and is ignored elsewhere, since
 * that is the only place to keep a history of previous steps.
 */
export const stepMetaHistoryClear = <T extends BaseStep>(step: T): StepMetaHistoryClear<T> => ({
	type: StepMetaType.HistoryClear,
	step,
})

/**
 * Resolve a step handler by closing the current view. This avoids having to return a step object that shouldn't
 * actually be shown, such as the same as what is expected to currently be shown. The effect is that the flow will never
 * exit loading, but expect to be closed or navigated shortly.
 */
export const stepMetaCloseView = (): StepMetaCloseView => ({ type: StepMetaType.CloseView })
